export default __webpack_public_path__ + "static/media/fld.9a93ec6f.svg";